import {
  Point,
  StaticPartVertexDto,
  StaticPartComponentDto,
  Rect,
  ViewBoxRect
} from '@refra/modules/refra-static-parts/types'

export const clientToSvgPoint = (
  e: React.PointerEvent,
  svgRef: React.MutableRefObject<SVGSVGElement | null>
): Point | null => {
  const svg = svgRef.current
  if (!svg) return null

  const screenPoint = new DOMPoint(e.clientX, e.clientY)
  const transformationMatrix = svg.getScreenCTM()
  if (!transformationMatrix) return null

  const svgPoint = screenPoint.matrixTransform(transformationMatrix.inverse())
  return {x: svgPoint.x, y: svgPoint.y}
}

export const createPolygonPath = (vertices: StaticPartVertexDto[]) =>
  vertices.map((v) => `${v.x},${-v.y}`).join(' ')

export const toViewBoxString = ({x, y, width, height}: ViewBoxRect) =>
  `${x} ${y} ${width} ${height}`

export const getViewBox = (selectedComponent: StaticPartComponentDto): ViewBoxRect => {
  const sectionVertices = selectedComponent.sections.flatMap((s) => s.vertices)
  const annotationVertices = selectedComponent.annotationShapes?.flatMap((s) => s.vertices) ?? []
  const labelPositions = selectedComponent.annotationLabels?.map((l) => l.position) ?? []
  const allVertices = [...sectionVertices, ...annotationVertices, ...labelPositions]

  if (allVertices.length === 0) return {x: 0, y: 0, width: 100, height: 100}

  let minX = allVertices[0].x
  let maxX = allVertices[0].x
  let minY = -allVertices[0].y
  let maxY = -allVertices[0].y

  allVertices.forEach((v) => {
    const x = v.x
    const y = -v.y
    if (x < minX) minX = x
    if (x > maxX) maxX = x
    if (y < minY) minY = y
    if (y > maxY) maxY = y
  })

  const width = maxX - minX
  const height = maxY - minY

  const padding = Math.max(width, height) * 0.05
  return {
    x: minX - padding,
    y: minY - padding,
    width: width + padding * 2,
    height: height + padding * 2
  }
}

export const rectsOverlap = (a: Rect, b: Rect) =>
  a.x < b.x + b.width && a.x + a.width > b.x && a.y < b.y + b.height && a.y + a.height > b.y
